import {createReducer, on} from '@ngrx/store';
import * as AuthActions from './auth.actions';

export interface AuthState {
 isLoginLoading: boolean;
  isSignupLoading: boolean;
  isForgotPasswordLoading: boolean;
  isResetPasswordLoading: boolean;
  isVerifyEmailLoading: boolean;
  isResendOtpLoading: boolean;
  isValidatePasswordResetOtpLoading: boolean;
  forgotPasswordEmail: string;
}

const initialState: AuthState = {
  isLoginLoading: false,
  isSignupLoading: false,
  isForgotPasswordLoading: false,
  isResetPasswordLoading: false,
  isVerifyEmailLoading: false,
  isResendOtpLoading: false,
  isValidatePasswordResetOtpLoading: false,
  forgotPasswordEmail: '',
};

export const authReducer = createReducer(
  initialState,

  on(AuthActions.login, (state) => ({
    ...state,
    isLoginLoading: true,
  })),

  on(AuthActions.loginSuccess, (state) => ({
    ...state,
    isLoginLoading: false,
  })),

  on(AuthActions.loginFailure, (state, props) => ({
    ...state,
    isLoginLoading: false,
  })),

  on(AuthActions.signup, (state) => ({
    ...state,
    isSignupLoading: true,
  })),

  on(AuthActions.signupSuccess, (state) => ({
    ...state,
    isSignupLoading: false,
  })),

  on(AuthActions.signupFailure, (state) => ({
    ...state,
    isSignupLoading: false,
  })),

  on(AuthActions.verifyEmail, (state) => ({
    ...state,
    isVerifyEmailLoading: true,
  })),

  on(AuthActions.verifyEmailSuccess, (state) => ({
    ...state,
    isVerifyEmailLoading: false,
    emailVerified: true,
  })),

  on(AuthActions.verifyEmailFailure, (state) => ({
    ...state,
    isVerifyEmailLoading: false,
  })),

  on(AuthActions.forgotPassword, (state, props) => ({
    ...state,
    forgotPasswordEmail: props.email,
    isForgotPasswordLoading: true,
  })),

  on(AuthActions.forgotPasswordSuccess, (state) => ({
    ...state,
    isForgotPasswordLoading: false,
  })),

  on(AuthActions.forgotPasswordFailure, (state) => ({
    ...state,
    isForgotPasswordLoading: false,
  })),

  on(AuthActions.resetPassword, (state) => ({
    ...state,
    isResetPasswordLoading: true,
    error: null
  })),

  on(AuthActions.resetPasswordSuccess, (state) => ({
    ...state,
    isResetPasswordLoading: false,
    forgotPasswordEmail: '',
  })),

  on(AuthActions.resetPasswordFailure, (state) => ({
    ...state,
    isResetPasswordLoading: false,
  })),

  on(AuthActions.resendOtp, (state) => ({
    ...state,
    isResendOtpLoading: true,
  })),

  on(AuthActions.resendOtpSuccess, (state) => ({
    ...state,
    isResendOtpLoading: false,
  })),

  on(AuthActions.resendOtpFailure, (state) => ({
    ...state,
    isResendOtpLoading: false,
  })),

  on(AuthActions.validatePasswordResetOtp, (state) => ({
    ...state,
    isValidatePasswordResetOtpLoading: true,
  })),

  on(AuthActions.validatePasswordResetOtpSuccess, (state) => ({
    ...state,
    isValidatePasswordResetOtpLoading: false,
  })),

  on(AuthActions.validatePasswordResetOtpFailure, (state) => ({
    ...state,
    isValidatePasswordResetOtpLoading: false,
  })),
);
